import React, { useState, useEffect } from 'react'
import Slider from "react-slick";
import { BaseUrl, getAssetUrl } from "../../helper/BaseUrl";
import axios from "axios";

export default function HomeLogoslider({initialData}) {
    const [clientLogo, setclientLogo] = useState(initialData || []);
    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/home-client-logo/edit`);
            setclientLogo(response.data.home_client_logos);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    if (!clientLogo) {
        return null;
    }

    const settings = {
        dots: false,
        arrows: false,
        slidesToShow: 6,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        pauseOnHover: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        speed: 5000,
        remove: true,
        centerMode: true,
        responsive: [
            {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            },
            },
            {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
            },
            },
            {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
            },
            },
            {
            breakpoint: 599,
            settings: {
                slidesToShow: 2,
            },
            },
        ],
    };

  return (
    <>
    <section className="partner-logo">
        <Slider {...settings}>
            {clientLogo.map((data,index)=>( 
            <div className="partnerlogo-box" key={index}>
                <img src={getAssetUrl(data?.logo)} className="img-responsive" loading="lazy" alt="logo" />
            </div>
            ))}
        </Slider>
    </section>
    </>
  )
}
